import { CustomButton } from "components/Common"
import CustomSearchBar from "components/Common/CustomTable/SearchBar"
import { columnsInstrumentMapping, columnsInstrumentMappingCode } from "constant"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect, useDispatch } from "react-redux"
import { getConnectorInstrumentMappingUploadSuccess } from "store/actions"
import { read, utils } from "xlsx"
import ButtonExport from "./ButtonExport"

const InstrumentTableButtons = ({
  onRefresh,
  onSearch,
  loadingInstrumentMapping,
  data,
  t,
  searchText,
  onChangeSearchText,
  onClearSearchText,
  onSubmit,
  onSetRows,
  instrumentMappings,
}) => {
  const [dataSource, setDataSource] = useState([])
  const [dataExport, setDataExport] = useState([])
  const [fileName, setFileName] = useState(t("common:Upload"))
  const [isUpload, setIsUpload] = useState(false)

  useEffect(() => {
    setDataSource(data)
  }, [data])
  const dispatch = useDispatch();

  const getDataExport = () => {
    let dt = dataExport.map(row => {
      let res = {}
      columnsInstrumentMapping.forEach(element => {
        res[element] = row[columnsInstrumentMappingCode[element]]
      });
      return res
    })
    return dt
  }

  useEffect(() => {
    setDataExport(instrumentMappings || [])
  }, [instrumentMappings])

  const getColumnExport = () => {
    return columnsInstrumentMapping
  }

  const getInstrumentHisString = (value) => {
    if (value) {
      return `${value}`
    }
    return null
  }

  const handleImport = e => {
    const files = e.target.files
    if (files.length) {
      let rowChoose = []
      const file = files[0]
      const reader = new FileReader()
      reader.onload = event => {
        const wb = read(event.target.result)
        const sheets = wb.SheetNames
        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]])
          let tmp = dataSource
          let rowChecked = [];
          rows.forEach(item => {
            if (item.instrumentHis && item.instrumentHis != '') {
              const ind = tmp.findIndex(x => x.manageCode == item.manageCode)
              if (ind >= 0) {
                tmp[ind].instrumentHis = getInstrumentHisString(item['instrumentHis']);
                tmp[ind].message = getInstrumentHisString(item['instrumentHis']);
                tmp[ind].selected = 1;
                rowChoose.push(tmp[ind])
                rowChecked.push(item)
              }
            }
          })
          dispatch(getConnectorInstrumentMappingUploadSuccess(tmp))
          onSetRows(rowChoose)
        }
      }
      reader.readAsArrayBuffer(file)
    }
  }

  return (
    <React.Fragment>
      <div className="input-table-header-tat-setting"
      >
        <CustomButton
          color="secondary"
          outline
          onClick={() => {
            onRefresh()
          }}
        >
          <i className={`fas fa-sync-alt ${loadingInstrumentMapping == true ? " loading-spin" : ""}`}></i>
        </CustomButton>
        <input
          id="importExcel"
          name="reportTemplateName"
          type="file"
          className=" d-none"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onChange={e => {
            setFileName(e.target.files[0]?.name || t("common:Upload"))
            handleImport(e)
          }}
        />
        <CustomButton
          isEdit
          color="primary"
          outline
          onClick={() => {
            $(`#importExcel`).click()
            setIsUpload(true)
          }}
        >
          {fileName}
        </CustomButton>
        <ButtonExport
          rows={dataSource}
          data={getDataExport()}
          columns={getColumnExport()}
        />
        <CustomButton
          color="primary"
          onClick={() => { onSubmit() }}
        >
          {t('button:Save')}
        </CustomButton>
        <CustomSearchBar
          onSearch={onChangeSearchText}
          searchText={searchText}
          placeholder={t("common:Search")}
          onClear={onClearSearchText}
          onSubmit={(e) => {
            e.preventDefault()
            onSearch()
          }}
        />
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = ({ hisConnector }) => ({
  loadingInstrumentMapping: hisConnector.loadingInstrumentMapping,
  instrumentMappings: hisConnector.instrumentMappings || []
})

const mapDispatchToProps = dispatch => ({

})

InstrumentTableButtons.displayName = 'InstrumentTableButtons';
export default withTranslation(["testConfig", "common", "button"], { withRef: true })(connect(
  mapStateToProps,
  mapDispatchToProps, null, { forwardRef: true }
)(InstrumentTableButtons))
